// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3XQnn","savePackageButton":"ClientWallet_savePackageButton__V8DK3"};